import * as bootstrap from 'bootstrap'

